import { render, staticRenderFns } from "./RouteHost.vue?vue&type=template&id=0fbe38c5"
import script from "./RouteHost.vue?vue&type=script&lang=js"
export * from "./RouteHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports